import React, { ChangeEvent } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business"; // Exemplo de ícone
import PeopleIcon from "@mui/icons-material/People"; // Exemplo de ícone
import PersonIcon from "@mui/icons-material/Person"; // Exemplo de ícone
import AccessTimeIcon from "@mui/icons-material/AccessTime"; // Exemplo de ícone
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"; // Ícone para o formulário

import { useContextLandingPages } from "src/Contexts/LandingPageContext/LandingPagesContext";
import { IInputCreateLeads } from "src/Contexts/Leads/LeadsTypes";
import { cpfOurCnpj } from "src/shared/Utils/MaskCpfCnpj";
import { useFormLandingPagePublic } from "../../Hooks/useFormLandingPagePublic";
import { FormCore } from "src/Pages/components/AppFormComponents/FormCore";

export const HeroSection = () => {
  const { setValuesInputsLeads, valuesInputsLeads } = useContextLandingPages();
  const { handleSubmit } = useFormLandingPagePublic();

  const handleChange =
    (prop: keyof IInputCreateLeads, option?: "cpf" | "phone") =>
    (event: ChangeEvent<HTMLInputElement>) => {
      if (option === "phone") {
        setValuesInputsLeads((eventPrev) => ({
          ...eventPrev,
          [prop]: cpfOurCnpj({ text: event.target.value, type: "phone" }),
        }));
      } else if (option === "cpf") {
        setValuesInputsLeads((eventPrev) => ({
          ...eventPrev,
          [prop]: cpfOurCnpj({ text: event.target.value, type: "cpf" }),
        }));
      } else {
        setValuesInputsLeads((eventPrev) => ({
          ...eventPrev,
          [prop]: event.target.value,
        }));
      }
    };

  return (
    <Box
      sx={{
        backgroundColor: "#0052CC",
        color: "white",
        py: { xs: 4, md: 10 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: "bold",
                mb: { xs: 2, sm: 3 },
                fontSize: { xs: "2rem", sm: "3rem", md: "3.5rem" }, // Responsividade da fonte
              }}
            >
              Economize no seu plano de saúde com ajuda profissional
            </Typography>
            <Typography
              variant="h6"
              component="p"
              sx={{ mb: { xs: 2, sm: 3 }, fontWeight: "normal", opacity: 0.9 }}
            >
              Atendimento humanizado, sem enrolação
            </Typography>

            {/* Lista de pontos */}
            <List dense sx={{ mb: 4 }}>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <ListItemIcon
                  sx={{ minWidth: "auto", mr: 1.5, color: "white" }}
                >
                  <CheckCircleOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Planos das maiores operadoras: Bradesco Saúde, Amil, SulAmérica, Hapvida, NotreDame Intermédica"
                  primaryTypographyProps={{ sx: { opacity: 0.9 } }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <ListItemIcon
                  sx={{ minWidth: "auto", mr: 1.5, color: "white" }}
                >
                  <BusinessIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Planos Empresariais"
                  primaryTypographyProps={{ sx: { opacity: 0.9 } }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <ListItemIcon
                  sx={{ minWidth: "auto", mr: 1.5, color: "white" }}
                >
                  <PeopleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Planos Familiares"
                  primaryTypographyProps={{ sx: { opacity: 0.9 } }}
                />
              </ListItem>
              <ListItem disablePadding sx={{ mb: 1 }}>
                <ListItemIcon
                  sx={{ minWidth: "auto", mr: 1.5, color: "white" }}
                >
                  <PersonIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Planos Individuais"
                  primaryTypographyProps={{ sx: { opacity: 0.9 } }}
                />
              </ListItem>
              <ListItem disablePadding>
                <ListItemIcon
                  sx={{ minWidth: "auto", mr: 1.5, color: "white" }}
                >
                  <AccessTimeIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary="Atendimento personalizado em até 5 minutos"
                  primaryTypographyProps={{ sx: { opacity: 0.9 } }}
                />
              </ListItem>
            </List>
          </Grid>

          {/* Coluna do Formulário */}
          <Grid item xs={12} md={6} id="contact-form">
            <Paper
              elevation={4}
              sx={{ p: { xs: 2, md: 4 }, borderRadius: "12px" }}
            >
              <Typography
                variant="h5"
                component="h2"
                sx={{ fontWeight: "bold", mb: 1, color: "text.primary" }}
              >
                Solicite sua cotação
              </Typography>
              <Typography
                variant="body2"
                sx={{ mb: 3, color: "text.secondary" }}
              >
                Receba um atendimento exclusivo agora mesmo
              </Typography>
              <FormCore
                onSubmit={handleSubmit}
                sxStyle={{ p: { xs: 0, md: 2 }, m: { xs: 0 } }}
              >
                <TextField
                  fullWidth
                  label="Seu nome completo *"
                  variant="outlined"
                  margin="normal"
                  required
                  value={valuesInputsLeads.name}
                  onChange={handleChange("name")}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Seu WhatsApp *"
                  variant="outlined"
                  margin="normal"
                  required
                  type="tel"
                  value={valuesInputsLeads.whats}
                  onChange={handleChange("whats", "phone")}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Seu e-mail *"
                  variant="outlined"
                  margin="normal"
                  type="email"
                  value={valuesInputsLeads.email}
                  onChange={handleChange("email")}
                  sx={{ mb: 3 }}
                />
                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  type="submit"
                  onClick={handleSubmit}
                  endIcon={<BusinessIcon />} // Usar ícone apropriado, talvez ArrowForward?
                  sx={{
                    backgroundColor: "#0052CC", // Azul principal
                    py: 1.5,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: "#0041A3", // Azul mais escuro
                    },
                  }}
                >
                  Falar com especialista
                </Button>
                <Typography
                  variant="caption"
                  display="block"
                  sx={{
                    mt: 1.5,
                    textAlign: "center",
                    color: "text.secondary",
                  }}
                >
                  Atendimento rápido e personalizado via WhatsApp
                </Typography>
              </FormCore>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
